import { useEffect, useRef } from 'react';

export const useMounted = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    // マウント時（StrictModeの2回目のマウント含む）にtrueに設定
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  // currentプロパティの代わりにgetterを使用
  return {
    get current() {
      return isMounted.current;
    }
  };
};
